"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPEN_PARENS = exports.CLOSE_PARENS = void 0;
/**
 * Represents end of a node in serialized format.
 */
exports.CLOSE_PARENS = ')';
/**
 * Represents start of a node in serialized format.
 */
exports.OPEN_PARENS = '(';
